import { PPLSIPayload } from '@legalshield/frontend-commons';

export default () => {
  if ('pplsi' in window) {
    return window.pplsi as PPLSIPayload;
  }
  return undefined;
};
